import React from 'react';

import { InterHeaderStyles } from '../../styles';
import { AggregatedSeriesType } from './series';
import { SeriesImage } from './series-image';

export const SeriesNameTemplate = ({
  data,
}: {
  data: AggregatedSeriesType;
}) => {
  return (
    <div className="flex items-start h-[40px] pt-2 gap-3">
      <SeriesImage
        images={(data.seriesImage || []).map(
          (img: { url?: string } | null) => img?.url,
        )}
      />

      <span title={data.name} className={InterHeaderStyles}>
        {data.name}
      </span>
    </div>
  );
};
